module.exports = __webpack_public_path__ + "media/images/icons/twotone/down-circle-ed9903b0af29e4ee59ad0c3958184a6f.svg";